import React from 'react';
import Typography from '@mui/material/Typography';

const KnownEVColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>CVE ID</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Vendor Project</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Product</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Vulnerability Name</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Required Action</Typography>
      </div>
    </>
  );
};

export default KnownEVColumns;
